import {
    Action,
    ActionType,
    EarlyBirdRuleWithUiId,
    EarlyBirdConditionWithUiId,
} from "app/pages/EarlyBirdOfferBuilder/actionTypes";
import { BuilderPageLoadedData } from "app/pages/EarlyBirdOfferBuilder/actionTypes";

export function pageLoaded(
    rules: EarlyBirdRuleWithUiId[],
    year: number,
    divisionId: number,
    data: BuilderPageLoadedData
): Action {
    return { type: ActionType.PageLoaded, rules, year, divisionId, data };
}

export function setRules(rules: EarlyBirdRuleWithUiId[]): Action {
    return { type: ActionType.SetRules, rules };
}

export function addRule(): Action {
    return { type: ActionType.AddRule };
}

export function removeRule(ruleIndex: number): Action {
    return { type: ActionType.RemoveRule, ruleIndex };
}

export function updateRule(
    ruleIndex: number,
    patch: Partial<{ name: string; earlyBirdEndDate: string }>
): Action {
    return { type: ActionType.UpdateRule, ruleIndex, patch };
}

export function addCondition(
    ruleIndex: number,
    lane: "include" | "exclude",
    condition: EarlyBirdConditionWithUiId
): Action {
    return { type: ActionType.AddCondition, ruleIndex, lane, condition };
}

export function removeCondition(
    ruleIndex: number,
    lane: "include" | "exclude",
    uiId: string
): Action {
    return { type: ActionType.RemoveCondition, ruleIndex, lane, uiId };
}

export function updateCondition(
    ruleIndex: number,
    lane: "include" | "exclude",
    uiId: string,
    condition: EarlyBirdConditionWithUiId
): Action {
    return { type: ActionType.UpdateCondition, ruleIndex, lane, uiId, condition };
}

export function setEditingConditionUiId(uiId: string | null): Action {
    return { type: ActionType.SetEditingConditionUiId, uiId };
}
